/** Round a number with a given amount of decimals */
export const round = (n: number, decimals = 0) => {
  const factor = 10 ** decimals
  return Math.round(n * factor) / factor
}

/** Return 0 if the value is negative */
export const zeroIfNegative = (n: number) => (n < 0 ? 0 : n)

/**
 * Renvoie le pourcentage d'évolution arrondi à l'entier.
 * Renvoie null si previous = 0 (cas indéterminé — afficher "NC" côté UI).
 */
export const computePercentageChange = (current: number, previous: number): number | null => {
  if (previous === 0) return null
  return Math.round(((current - previous) / previous) * 100)
}
